import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-path=\"url(#a)\" clip-rule=\"evenodd\"><path d=\"M7.704.743a.61.61 0 0 1 .592 0l6.032 3.334c.208.115.339.342.339.59V6c0 .368-.285.667-.635.667H1.968c-.35 0-.635-.299-.635-.667V4.667c0-.248.131-.475.34-.59zm-5.1 4.326v.264h10.793V5.07L8 2.087zm-1.27 7.598c0-.368.284-.667.634-.667h12.064c.35 0 .635.299.635.667v2c0 .368-.285.666-.635.666H1.968c-.35 0-.635-.298-.635-.666zm1.27.666V14h10.793v-.667z\"></path><path d=\"M5.143 12.667V6h1.27v6.667zM2.603 12.667V6h1.27v6.667zM9.587 12.667V6h1.27v6.667zM12.127 12.667V6h1.27v6.667z\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M0 0h16v16H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })